import React from "react";
import "./ProjectCardCompact.css";

interface ProjectCardCompactProps {
  icon: string;
  name: string;
  onClick?: () => void;
}

const ProjectCardCompact: React.FC<ProjectCardCompactProps> = ({ icon, name, onClick }) => (
  <div className="project-card-compact" onClick={onClick}>
    <span className="project-icon">{icon}</span>
    <span className="project-name">{name}</span>
  </div>
);

export default ProjectCardCompact; 